import axios from '@/utils'

// 我购买的订单列表
export function newBuyList (params) {
    return axios({
        method: 'get',
        url: '/order/newBuyList',
        params
    })
}

// 我的求购列表
export function applyList (params) {
    return axios({
        method: 'get',
        url: '/transfer/apply_list',
        params
    })
}

// 我的购买订单取消
export function cancelOrder (data) {
    return axios({
        method: 'post',
        url: '/order/cancelOrder',
        data
    })
}

// 订单详情
export function orderInfo (data) {
    return axios({
        method: 'post',
        url: '/order/info',
        data
    })
}

// 御守盲盒订单详情
export function exchange_detail (params) {
    return axios({
        method: 'get',
        url: '/yushou/order/detail',
        params
    })
}

// 求购订单详情
export function apply_detail (data) {
    return axios({
        method: 'post',
        url: '/transfer/apply_detail',
        data
    })
}

// 【新】求购支付
export function transfer_pay (data) {
    return axios({
        method: 'post',
        url: '/transfer/pay',
        data
    })
}

// 【新】购买支付
export function origin_pay (data) {
    return axios({
        method: 'post',
        url: '/origin/pay',
        data
    })
}

